import React, { ReactElement } from 'react';
import AppLogoBrand from './AppLogoBrand';

interface Props {
    height?: number;
    width?: number;
    useExtended?: boolean;
}

function AppLogoBrandGoogleCloud({
    height = 28,
    width = 90,
    useExtended = true,
}: Props): ReactElement {
    return (
        <AppLogoBrand
            height={height}
            logo={
                useExtended
                    ? 'provider-googlecloud-brand-logo'
                    : 'provider-googlecloud-brand-logo-short'
            }
            size=""
            testId="AppLogoBrandGoogleCloud"
            width={width}
        />
    );
}

export default AppLogoBrandGoogleCloud;
